import { render, staticRenderFns } from "./fsModalAdd.vue?vue&type=template&id=9482a2fa&scoped=true"
import script from "./fsModalAdd.vue?vue&type=script&lang=js"
export * from "./fsModalAdd.vue?vue&type=script&lang=js"
import style0 from "./fsModalAdd.vue?vue&type=style&index=0&id=9482a2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9482a2fa",
  null
  
)

export default component.exports